/**
 * What the price pill of the TopBar shows when the order button carries the upload progress :
 * "Prix" over the price, then a chevron, to the left of the cart. Shown on hover only.
 */
fx.ns("desktop.common.actionbar", class OrderPrice extends fx.Component {

	constructor(price)
	{
		super();

		this._price = price;
	}

	get price()
	{
		return this._price;
	}

	set price(val)
	{
		this._price = val;

		if (this.node)
			this.find(".price").innerHTML = val;
	}

	render()
	{
		return '<div class="amount"><span class="infos">' + fx.text("Prix") + '</span><span class="price">' + this._price + '</span></div>'
			+ '<svg class="chevron" width="14" height="22" viewBox="0 0 14 22"><path d="M3 3l8 8-8 8"></path></svg>';
	}

});
